module.exports = __webpack_public_path__ + "static/zdjęcia17-f2f6547a5b7312f0f07c865ee285f91d.svg";